import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationRequirementCS {
    csRouteID: number;
    operationNumber: number;
    dataAreaID: string;
    routeId: string;
    routeOperationId: string;
    productionSiteId: string;
    itemNumber: string;
    willJobSchedulingUseRequirement: string;
    willOperationSchedulingUseRequirement: string;
    requiredOperationsResourceGroupId: string;
    requiredOperationsResourceId: string;
    requiredCapabilityName: string;
}

export const getRouteOperationRequirementsCS = async (
    csRouteID: number,
): Promise<IRouteOperationRequirementCS[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationRequirementCS[]>(
        `/RouteOperation/GetRouteOperationRequirementsCS/${csRouteID}`,
    );
    return response.data;
};
